import dayjs from "../utils/dayjs";
let timezone = dayjs.tz.guess();
// eslint-disable-next-line @typescript-eslint/no-unused-vars

export function formatDate(inputDate: string) {
  if (!inputDate) return '';

  const d = new Date(inputDate);

  let date = d.getDate().toString().padStart(2, '0');
  let month = (d.getMonth() + 1).toString().padStart(2, '0');
  let year = d.getFullYear();

  return `${year}-${month}-${date}`;
};

export function formatDateWithDay(inputDate: string) {
  if (!inputDate) return '';
  return dayjs(inputDate).format(' MMM D, YYYY ');
}

export function getTimeZoneDate(inputDate: string, format?: string) {
  if (!inputDate) return '';
  if (!format) return dayjs.utc(inputDate).tz(timezone);

  return dayjs.utc(inputDate).tz(timezone).format(format)
};

export function formatDateBy(inputDate: string) {
  if (!inputDate) return '';

  const d = new Date(inputDate);

  let date = d.getDate().toString().padStart(2, '0');
  let month = (d.getMonth() + 1).toString().padStart(2, '0');
  let year = d.getFullYear();

  return `${date}-${month}-${year}`;
};
export function getDays(inputDate: string) {
  if (!inputDate) return '';

  const d = new Date(inputDate);

  const diffInMs   = new Date() - d
  const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

  return Math.floor(diffInDays);
};

export function removeBlankKeyfromObject(obj: any) {
  if (!obj) return {}
  if (!Object.keys(obj).length) return {}

  const newObj: any = {}

  Object.keys(obj).forEach(key => {
    if (obj[key] || obj[key] === 0) {
      newObj[key] = obj[key]
    }
  })

  return newObj;
}